import { inertia as inertiaAction } from '@inertiajs/svelte'
import { fromAction, type Attachment } from 'svelte/attachments'

export type LinkParameters = NonNullable<Parameters<typeof inertiaAction>[1]>

// Inertia's `inertia` action prefers the element's current `href` over the `href` param, as an absolute URL that it then
// writes back, and keeps visiting its first target even after its params change (e.g. after switching the locale).
// Removing the attribute before the action reads it makes the action use the `href` param as given.
const link: typeof inertiaAction = (node, initialParameters) => {
  node.removeAttribute('href')
  const action = inertiaAction(node, initialParameters)

  return {
    ...action,
    update(parameters: LinkParameters) {
      node.removeAttribute('href')
      action.update?.(parameters)
    },
  }
}

export function inertia(parameters: LinkParameters): Attachment<HTMLElement> {
  return fromAction(link, () => parameters)
}
